import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row, Table, } from "reactstrap";
import { Btn, H1, } from "../../../AbstractElements";
import { convertirEnNombre, URL_API } from "../../../utils/helper/helpers";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ActualFileUpload, DropFileUploadText, DropFilesHereOrClickToUpload } from '../../../utils/Constant';
import { Dropzone, FileMosaic, ExtFile } from "@dropzone-ui/react";
import { H6 } from '../../../AbstractElements';
import useInfosEts from "../../InfosEts/InfoApi";
import SweetAlert from 'sweetalert2';
import { formatPrice } from "../../../utils/helper/helpers";
import axios from "axios";
import { useMaterielPrice } from "../../MaterielPrice/materielApi";
import { AddEtsTransitaire } from "../../../utils/helper/modal";

const Formulaires = ({ id_fournisseur, type }: { id_fournisseur: number, type: string }) => {

    const [refresh, setRefresh] = useState(false);
    const navigate = useNavigate();
    const Token = JSON.parse(localStorage.getItem("login")!);

    const [selectedMateriel, setSelectedMateriel] = useState<string>("");
    const [price, setPrice] = useState('');
    const [repartion, setRepartition] = useState(false);
    const [quantity, setQuantity] = useState<number>(0);

    const infosEts = useInfosEts(refresh) || [];

    const updateFiles = (incomingFiles: ExtFile[]) => {
        setData((prevState) => ({
            ...prevState,
            file: incomingFiles,
            recu: incomingFiles[0]?.file || null,
        }));
    };
    const removeFile = (id: string | number | undefined) => {
        setData((prevState) => ({
            ...prevState,
            file: data.file.filter((x: ExtFile) => x.id !== id),
            recu: null
        }));
    };

    const [data, setData] = useState({
        montant: "",
        receveur: "",
        montant_avancer: "",
        materiel: [] as { materiel: string; price: number; quantity: number }[],
        mode_payment: "",
        num_paiement: "",
        date_versement: "",
        date_paiement: "",
        isChecked: 0,
        idfournisseur: id_fournisseur,
        selectType: 'transitaire',
        idinfos: null,
        recu: null as File | null,
        file: [] as ExtFile[],
        id: null,
    });

    const [erreur, setErreur] = useState({
        montant: '',
        receveur: '',
        montant_avancer: "",
        materiel: '',
        mode_payment: '',
        num_paiement: '',
        date_versement: '',
        date_paiement: "",
        isChecked: '',
        idfournisseur: null,
        idinfos: null,
        recu: [] as ExtFile[],
        id: null
    });

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;

        const formatMontant = (valeur: string) => {
            const montantNettoye = valeur.replace(/[^\d]/g, '');
            return montantNettoye.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        };

        const formattedValue = name === "montant" ? formatMontant(value) : name === "montant_avancer" ? formatMontant(value) : value;

        setData((prevState) => ({
            ...prevState,
            [name]: formattedValue
        }));
    };

    const handleMaterielChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selected = e.target.value;
        setSelectedMateriel(selected);
    };

    const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selected = e.target.value;
        const formatMontant = (valeur: string) => {
            const montantNettoye = valeur.replace(/[^\d]/g, '');
            return montantNettoye.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        };
        setPrice(formatMontant(selected));
    };

    const handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setQuantity(Number(e.target.value));
    };

    // Ajouter une ligne au tableau des matériaux
    const addToTable = () => {
        if (selectedMateriel && price && quantity > 0) {
            // Vérifier si l'élément existe déjà dans le tableau
            const exists = data.materiel.some((item) => item.materiel === selectedMateriel);
    
            if (!exists) {
                // Vérification de la répartition anormale
                const totalMontant = data.materiel.reduce(
                    (acc, item) => acc + item.quantity * item.price,
                    0
                );
                const montantAjoute = convertirEnNombre(price) * quantity;
    
                if (totalMontant + montantAjoute > convertirEnNombre(data.montant)) {
                    toast.info('Répartition anormale');
                    setRepartition(true);
                    return;
                }
    
                // Ajouter l'élément au tableau
                setData((prevData) => ({
                    ...prevData,
                    materiel: [
                        ...prevData.materiel,
                        { materiel: selectedMateriel, price: convertirEnNombre(price), quantity },
                    ],
                }));
    
                // Réinitialiser les champs
                setSelectedMateriel("");
                setPrice('');
                setQuantity(0);
                setRepartition(false);
            } else {
                toast.info("Cet élément est déjà ajouté au tableau.");
            }
        } else {
            toast.error("Veuillez remplir tous les champs correctement.");
        }
    };
    
    // Supprimer une ligne du tableau des matériaux
    const removeFromTable = (index: number) => {
        setData((prevData) => ({
            ...prevData,
            materiel: prevData.materiel.filter((_, i) => i !== index),
        }));
    };

    useEffect(() => {

        setData((prevState) => ({
            ...prevState,
            idfournisseur: id_fournisseur,
            selectType: 'transitaire',

        }));
    }, [id_fournisseur]);

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();

        SweetAlert.fire({
            title: 'Informations',
            text: " Les données doivent être envoyé et ne peuvent pas être modifiées ou supprimées !",
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, Envoyer'
        }).then((result) => {
            if (result.isConfirmed) {
                console.log(data)
                axios.post(`${URL_API}/versement/store`, { ...data }, {
                    headers: {
                        Authorization: `Bearer ${Token}`,
                        'Content-Type': 'multipart/form-data',
                    }
                }).then(response => {
                    if (response.data.success) {
                        const msg = "Versement ajouté avec succès !!";
                        toast.success(msg);
                        clearDataForm();
                    }

                }).catch(error => {
                    toast.info("Oups !! Erreur de modification des données");
                    if (error.response && error.response.data.success === false) {
                        const newErrors = error.response.data.message;
                        console.log(newErrors)
                        setErreur(prevErrors => ({
                            ...prevErrors,
                            ...newErrors,
                        }));
                    }
                })
            } else {
                toast.info('Vueillez renseigner tous les champs')
            }

        });

    }

    const clearDataForm = () => {
        setData({
            montant: "",
            receveur: "",
            montant_avancer: "",
            materiel: [] as { materiel: string; price: number; quantity: number }[],
            mode_payment: "",
            num_paiement: "",
            date_versement: "",
            date_paiement: "",
            isChecked: 0,
            idfournisseur: id_fournisseur,
            selectType: 'transitaire',
            idinfos: null,
            recu: null as File | null,
            file: [] as ExtFile[],
            id: null,
        });
        setErreur({
            montant: '',
            receveur: '',
            montant_avancer: "",
            mode_payment: '',
            materiel: '',
            num_paiement: '',
            isChecked: '',
            date_paiement: "",
            date_versement: '',
            idinfos: null,
            idfournisseur: null,
            recu: [] as ExtFile[],
            id: null
        });
        navigate('/autres-versement')
    }

    const [modalClient, setModalClient] = useState(false);
    const staticModalClientToggle = () => setModalClient(!modalClient);

    const openModalWithRow = () => {
        setModalClient(true);
    };

    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked;
        setIsChecked(checked);
        setData((prevState) => ({
            ...prevState,
            isChecked: checked ? 1 : 0,
        }));
    };


    return (
        <div className='page-body'>
            <Container fluid>
                <Card>
                    <CardBody>
                        <Form onSubmit={handleSubmitData}>
                            <H1 className="mb-2 text-capitalize text-center fw-bold">
                                 {
                                    type == 'diamond' ? 'DIAMOND KAGBELEN' : 'DIAMOND SOUGUETA'
                                 }
                            </H1>
                            <div className="product-info">
                                <div className="product-group">
                                    <Row>
                                        <Col sm="12">
                                            
                                            <FormGroup>
                                                <Label>Etablissement<span className="text-danger">*</span> </Label>
                                                <Row>
                                                    <Col sm="9">
                                                        <Input
                                                            placeholder="Entrer le type"
                                                            name="idinfos"
                                                            value={data.idinfos || ''}
                                                            onChange={changeHandler}
                                                            type="select"
                                                            className="form-control"
                                                        >
                                                            <option value=''>Sélectionner...</option>
                                                            {infosEts.map((item, index) => {
                                                                if (item.status === 'actif' && item.type === 'Transitaire') {
                                                                    return <option key={index} value={item.id}>{item.nom}</option>;
                                                                }
                                                                return null;
                                                            })}
                                                        </Input>
                                                    </Col>
                                                    <Col sm="3">
                                                        <Btn color="light-dark" className="w-100 for-light" onClick={() => openModalWithRow()}>Ajouter un transitaire</Btn>
                                                        <Btn color="light-light" className="w-100 for-dark" onClick={() => openModalWithRow()}>Ajouter un transitaire</Btn>
                                                    </Col>
                                                </Row>
                                                {erreur.idinfos && (
                                                    <span className="text-danger">{erreur.idinfos}</span>
                                                )}
                                            </FormGroup>
                                               
                                            
                                        </Col>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label>Montant<span className="text-danger">*</span></Label>
                                                <Input
                                                    placeholder="Entrer le montant"
                                                    name="montant"
                                                    value={data.montant}
                                                    onChange={changeHandler}
                                                    type="text"
                                                />
                                                {erreur.montant && (
                                                    <span className="text-danger">{erreur.montant}</span>
                                                )}
                                            </FormGroup>
                                        </Col>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label>Date de versement<span className="text-danger">*</span></Label>
                                                <Input
                                                    placeholder="Entrer le quantité sac"
                                                    name="date_versement"
                                                    value={data.date_versement}
                                                    onChange={changeHandler}
                                                    type="date"
                                                />
                                                {erreur.date_versement && (
                                                    <span className="text-danger">{erreur.date_versement}</span>
                                                )}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {
                                            data.materiel.length < 3 ? (
                                                <>
                                                    <Col sm={3}>
                                                        <Label>Materiel<span className="text-danger">*</span></Label>
                                                        <Input
                                                            type="select"
                                                            value={selectedMateriel}
                                                            onChange={handleMaterielChange}
                                                            className="form-control"
                                                        >
                                                            <option value="">Sélectionner...</option>
                                                            <option value="cements CPJ 32.5">cements CPJ 32.5</option>
                                                            <option value="cements CPJ 42.5">cements CPJ 42.5</option>
                                                            <option value="cements CPJ 52.5">cements CPJ 52.5</option>
                                                            {/* {materielPrice.map((item) => {
                                                                if (item.four_type == type) {
                                                                    return (
                                                                        <option key={item.id} value={item.materiel}>
                                                                            {item.materiel}
                                                                        </option>
                                                                    )
                                                                } return null
                                                            })} */}
                                                        </Input>
                                                    </Col>
                                                    <Col sm={3}>
                                                    <Label>Prix / Tonnes<span className="text-danger">*</span></Label>
                                                    <Input
                                                            type="text"
                                                            onChange={handlePriceChange}
                                                            value={price}
                                                            placeholder="Prix"
                                                        />
                                                    </Col>
                                                    <Col sm={3}>
                                                    <Label>Qte de tonnes<span className="text-danger">*</span></Label>
                                                        <Input
                                                            type="number"
                                                            value={quantity}
                                                            placeholder="Quantité"
                                                            onChange={handleQuantityChange}
                                                        />
                                                    </Col>
                                                    <Col sm={3}>
                                                        <Button color="light-dark" onClick={addToTable} className="mt-4 w-100 for-light">
                                                            Ajouter
                                                        </Button>
                                                        <Button color="light-light" onClick={addToTable} className="mt-4 w-100 for-dark">
                                                            Ajouter
                                                        </Button>
                                                    </Col>
                                                </>
                                            ) : (
                                                null
                                            )
                                        }

                                        <Col sm={12}>
                                        {repartion && (
                                                    <span className="text-danger">La repartition des tonnes ne correspond pas au montant globale</span>
                                                )}
                                            <Table className="mb-4" responsive striped>
                                                <thead>
                                                    <tr>
                                                        <th>Matériel</th>
                                                        <th>Prix</th>
                                                        <th>Quantité</th>
                                                        <th>Montant</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data.materiel.map((row, index) => (
                                                        <tr key={index}>
                                                            <td>{row.materiel}</td>
                                                            <td>{row.price.toLocaleString()} GNF</td>
                                                            <td>{row.quantity}</td>
                                                            <td>{formatPrice(row.quantity * row.price)}</td>
                                                            <td>
                                                                <Btn color="light-danger" size="xs" type="button" onClick={() => removeFromTable(index)}>
                                                                    Supprimer
                                                                </Btn>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm='12'>
                                            <FormGroup className="text-center">
                                                <Label className="mx-1 text-capitalize fw-bold fs-6" for="paiement" check>
                                                    <Input
                                                        className="checkbox-primary checkbox-border-primary"
                                                        onChange={handleCheckboxChange}
                                                        name="paiement"
                                                        id="paiement"
                                                        type="checkbox"
                                                        checked={isChecked}
                                                    />
                                                        AVANCER LE VERSEMENT ?
                                                </Label>
                                                {erreur.isChecked && (
                                                                <span className="text-danger">{erreur.isChecked}</span>
                                                            )}
                                            </FormGroup>
                                        </Col>
                                        {
                                            isChecked ? (
                                                <>
                                                    <Col sm="12">
                                                        <FormGroup>
                                                            <Label>Receveur<span className="text-danger">*</span></Label>
                                                            <Input
                                                                placeholder="Entrer le nom complet du receveur de l'avance payé"
                                                                name="receveur"
                                                                value={data.receveur}
                                                                onChange={changeHandler}
                                                                type="text"
                                                            />
                                                            {erreur.receveur && (
                                                                <span className="text-danger">{erreur.receveur}</span>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm="6">
                                                        <FormGroup>
                                                            <Label>Montant Avancé<span className="text-danger">*</span></Label>
                                                            <Input
                                                                placeholder="Entrer le montant avancé"
                                                                name="montant_avancer"
                                                                value={data.montant_avancer}
                                                                onChange={changeHandler}
                                                                type="text"
                                                            />
                                                            {erreur.montant_avancer && (
                                                                <span className="text-danger">{erreur.montant_avancer}</span>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm="6">
                                                        <FormGroup>
                                                            <Label>Mode de paiement<span className="text-danger">*</span></Label>
                                                            <Input
                                                                placeholder="Entrer le type"
                                                                name="mode_payment"
                                                                value={data.mode_payment || ''}
                                                                onChange={changeHandler}
                                                                type="select"
                                                                className="form-control"
                                                            >
                                                                <option value=''>Sélectionner...</option>
                                                                <option value='Chèque'>Chèque</option>
                                                                <option value='Espèce'>Espece ou Liquide</option>
                                                                <option value='Virement Bancaire'>Virement Bancaire</option>
                                                                <option value='Aucun'>Aucun</option>
                                                            </Input>
                                                            {erreur.mode_payment && (
                                                                <span className="text-danger">{erreur.mode_payment}</span>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm="6">
                                                        <FormGroup>
                                                            <Label>Numéro de paiement<span className="text-danger">*</span></Label>
                                                            <Input
                                                                placeholder="Entrer le numero de paiement"
                                                                name="num_paiement"
                                                                value={data.num_paiement}
                                                                onChange={changeHandler}
                                                                type="text"
                                                            />
                                                            {erreur.num_paiement && (
                                                                <span className="text-danger">{erreur.num_paiement}</span>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm="6">
                                                        <FormGroup>
                                                            <Label>Date de paiement<span className="text-danger">*</span></Label>
                                                            <Input
                                                                placeholder="Entrer le quantité sac"
                                                                name="date_paiement"
                                                                value={data.date_paiement}
                                                                onChange={changeHandler}
                                                                type="date"
                                                            />
                                                            {erreur.date_paiement && (
                                                                <span className="text-danger">{erreur.date_paiement}</span>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                </>
                                            ) : (
                                                null
                                            )
                                        }
                                        <Col sm='12'>
                                            <FormGroup>
                                                <Label check>Importer le justificatif</Label>
                                                <Dropzone onChange={updateFiles} value={data.file} maxFiles={1} header={false} footer={false} minHeight="80px" label="Drag'n drop files here or click to Browse">
                                                    {data.file.map((file: ExtFile) => (
                                                        <FileMosaic key={file.id} {...file} onDelete={removeFile} info={true} />
                                                    ))}
                                                    {data.file.length === 0 && (
                                                        <div className="dz-message needsclick p-5">
                                                            <i className="icon-cloud-up font-primary"></i>
                                                            <H6>{DropFilesHereOrClickToUpload}</H6>
                                                            <span className="note needsclick">
                                                                {DropFileUploadText}<strong>not</strong>{ActualFileUpload}
                                                            </span>
                                                        </div>
                                                    )}
                                                </Dropzone>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="text-end">
                                <Btn color="info" type="submit">Envoyer</Btn>
                                <Btn className="btn btn-danger ms-3" onClick={() => clearDataForm()}>Annuler</Btn>
                            </div>
                        </Form>
                    </CardBody>
                    {
                     AddEtsTransitaire({
                         isOpen: modalClient,
                         toggle: staticModalClientToggle,
                     }, () => setRefresh(!refresh))
                }
                </Card>

            </Container>
        </div>
    )
}

export default Formulaires;